/**
 * Échelle pdf.js pour faire tenir la 1re page d'un PDF dans une vignette
 * carrée de `box` px (côté le plus long = box), sans jamais agrandir une page
 * déjà petite. Pure, testée à part du rendu canvas.
 */
export const pdfThumbnailScale = (pageWidth: number, pageHeight: number, box: number): number => {
  const longest = Math.max(pageWidth, pageHeight);
  if (!Number.isFinite(longest) || longest <= 0) return 1;
  return Math.min(1, box / longest);
};
